<template>
<span>
  <ct-button :circle="true" @click="showSignatureModal">
    <ct-icon name="pencil"></ct-icon>
  </ct-button>
  <ct-modal :title="$t('user.EditSignature')"
    v-if="visible"
    @closed="closedModal">
    <div slot="body">
      <div class="input-container">
          <textarea
            :maxlength="maxlength"
            v-model="signature"
            class="edit-input"
            :placeholder="$t('user.EditSignaturePlaceholder')"
            rows="12">
          </textarea>
      </div>
      <div class="input-count-tip">
        <span class="input-count-tip--count">{{count}}</span>
        <span>/{{maxlength}}</span>
      </div>
      <p class="input-hint">{{ $t('user.EditSignatureTips') }}</p>
    </div>
    <div slot="footer">
      <ct-button type="text_secondary_light" @click.prevent="closedModal">{{ $t('common.Cancel') }}</ct-button>
      <ct-button
      type="primary"
      :disabled="count<=0||count>maxlength"
      :isLoading="loading"
      @click.prevent="handleSubmit"
      >{{ $t('common.Submit') }}</ct-button>
    </div>
  </ct-modal>
</span>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'EditAptions',
  data () {
    return {
      visible: false,
      pending: false,
      signature: '',
      maxlength: 200
    }
  },
  watch: {
    profile (value) {
      this.signature = value.signature || ''
    },
    signature (value) {
      if (value && value.length && value.length > this.maxlength) {
        this.signature = this.signature.slice(0, this.maxlength)
      }
    }
  },
  computed: {
    ...mapGetters(['profile']),
    count () {
      const signature = this.signature.toString()
      return signature.length
    },
    loading () {
      return this.pending
    }
  },
  methods: {
    ...mapActions(['updateUserInfo']),
    showSignatureModal () {
      this.visible = true
    },
    handleSubmit () {
      this.pending = true
      this.updateUserInfo({
        data: {
          signature: this.signature,
          nickname: this.profile.nickname,
          username: this.profile.username,
          grade: this.profile.grade,
          school: this.profile.school
        }
      }).then(data => {
        this.pending = false
        if (data.code === 1) {
          this.closedModal()
          this.$toast({ message: this.$t('common.SubmitSuccess'), type: 'success', duration: 2000 })
        } else {
          this.$toast({ message: data.error, type: 'warning', duration: 2000 })
        }
      }, () => {
        this.pending = false
      })
    },
    closedModal () {
      this.visible = false
    }
  },
  mounted () {
    this.signature = this.profile.signature || ''
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/_varaible.scss';

$textColor: #A3B1BF;
.is-circle{
  font-size: inherit;
}
// .input{
//   &-container{
//     font-size:14px;
//     line-height:22px;
//     font-family:SFProDisplay-Regular;
//   }
//   &-count-tip {
//     text-align: right;
//     color: $textColor;
//     &--count{
//       color: $secondary;
//     }
//   }
//   &-hint{
//     line-height:22px;
//     color: $textColor;
//     text-align: left;
//   }
// }
.edit-input{
  background-color: #fff;
  border-radius:2px;
  font-weight:400;
  color:$secondary;
  width: 100%;
  outline: none;
  resize: vertical;
  padding: 12px;
  font-size: inherit;
  border:1px solid rgba(218,224,229,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
</style>
